import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-confirm-draft',
  templateUrl: './confirm-draft.component.html',
  styleUrls: ['./confirm-draft.component.scss']
})
export class ConfirmDraftComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
